module.exports = __webpack_public_path__ + "static/media/py.3cccc8b3.svg";